import { Permissions } from "../Permissions";
import { Roles, Role } from "../Roles";
import { useRole } from "./useRole";


export function usePermission(permissions: Permissions[] | undefined): boolean {
  const role = useRole();

  return getPermission(role, permissions);
}

/**
 * get permission result for role and user
 * @param role role of user
 * @param permissions list of user permissions
 */
export function getPermission(role: string, permissions: Permissions[] | undefined): boolean {
  if (permissions === undefined) {
    return false;
  }
  switch(role) {
    case Role.EHPC_READ:
      return permissions.some(p => Roles.EHPC_READ.includes(p));
    case Role.EHPC_REQU:
      return permissions.some(p => Roles.EHPC_REQU.includes(p));
    case Role.EHPC_RW:
      return permissions.some(p => Roles.EHPC_RW.includes(p));
    default:
      return false;
  }
}
